var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "resetPassword" }, [
    _c("div", { staticClass: "center" }, [
      _c("h1", [
        _c("span", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("schoolAccountResetPasswordPage.subtitle"))),
        ]),
        _c("br"),
        _vm._v(
          " " + _vm._s(_vm.$t("schoolAccountResetPasswordPage.title")) + " "
        ),
      ]),
      _c("p", {
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("schoolAccountResetPasswordPage.description")
          ),
        },
      }),
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("text-field", {
                staticClass: "input",
                attrs: {
                  type: "email",
                  label: _vm.$t("schoolAccountResetPasswordPage.emailLabel"),
                },
                model: {
                  value: _vm.username,
                  callback: function ($$v) {
                    _vm.username = $$v
                  },
                  expression: "username",
                },
              }),
            ],
            1
          ),
          _c(
            "button-default",
            { attrs: { disable: !_vm.username || _vm.submitting } },
            [
              _vm._v(
                _vm._s(_vm.$t("schoolAccountResetPasswordPage.submitButton"))
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.message,
              expression: "message",
            },
          ],
          staticClass: "warning",
        },
        [_vm._v(_vm._s(_vm.message))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }